import { createSlice } from '@reduxjs/toolkit';
import { getAuditTrailThunk } from './AuditTrailActions';

export interface IAuditTrailData {
  loading: boolean;
  auditTrailHistory: any;
}

const initialState: IAuditTrailData = {
  loading: false,
  auditTrailHistory: [],
};

const auditTrailSlice = createSlice({
  name: 'Audit Trail',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAuditTrailThunk.pending, (state) => {
        state.loading = true;
        state.auditTrailHistory = [];
      })
      .addCase(getAuditTrailThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.auditTrailHistory = action.payload || [];
      })
      .addCase(getAuditTrailThunk.rejected, (state) => {
        state.loading = false;
        state.auditTrailHistory = [];
      });
  },
});

export default auditTrailSlice.reducer;
